/**
 * matchEndHonor — Post-game MVP / honor stub actions (SPY-315).
 */

export const MATCH_END_HONOR_ACTIONS = Object.freeze({
  mvp: Object.freeze({
    id: 'mvp',
    label: 'MVP',
    restartsTelemetry: false
  }),
  honor: Object.freeze({
    id: 'honor',
    label: 'Honor teammate',
    restartsTelemetry: false
  })
});

/**
 * @param {string} actionId
 * @returns {{ id: string, label: string, restartsTelemetry: boolean }|null}
 */
export function resolveMatchEndHonorAction(actionId) {
  if (!actionId || typeof actionId !== 'string') return null;
  return MATCH_END_HONOR_ACTIONS[actionId] || null;
}
